"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TIME = exports.DATE = exports.timeFormat = exports.dateFormat = exports.classes = void 0;
var classes = {
  container: 'generic-condition-header-class',
  headerClass: 'header-class',
  marginTop32: 'margin-top-32',
  marginTop8: 'margin-top-8'
};
exports.classes = classes;
var dateFormat = 'DD/MM/YYYY h:mm A';
exports.dateFormat = dateFormat;
var timeFormat = 'h:mm A';
exports.timeFormat = timeFormat;
var DATE = 'date';
exports.DATE = DATE;
var TIME = 'time';
exports.TIME = TIME;